import React, { useState, useEffect, useRef } from 'react';
import { videoUrls } from '../../mock';

/** Lazy YouTube Video - only loads iframe when in viewport */
const LazyVideo = React.memo(({ url, title }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const currentRef = containerRef.current;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px', threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      observer.disconnect();
    };
  }, []);

  // Extract video ID for thumbnail
  const videoId = url.split('/').pop();
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <div ref={containerRef} className="video-wrapper">
      {isVisible ? (
        <>
          {!isLoaded && (
            <div 
              className="video-placeholder" 
              style={{ backgroundImage: `url(${thumbnailUrl})` }}
              aria-hidden="true"
            >
              <div className="video-play-button">{'\u25B6'}</div>
            </div>
          )}
          <iframe
            src={`${url}?rel=0`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; compute-pressure"
            allowFullScreen
            loading="lazy"
            onLoad={() => setIsLoaded(true)}
            style={{ opacity: isLoaded ? 1 : 0 }}
          />
        </>
      ) : (
        <div 
          className="video-placeholder" 
          style={{ backgroundImage: `url(${thumbnailUrl})` }}
          aria-label={title}
        >
          <div className="video-play-button" aria-hidden="true">{'\u25B6'}</div>
        </div>
      )}
    </div>
  );
});

LazyVideo.displayName = 'LazyVideo';

const VideoSection = ({ t, language }) => {
  return (
    <section id="video" className="video-section" aria-labelledby="video-title">
      <h2 id="video-title" className="section-title">
        {language === 'cs' ? (
          <>Podívejte se na <span className="title-brand">UrbanCage<sup className="trademark">{'\u00AE'}</sup></span> v akci</>
        ) : (
          <>See <span className="title-brand">UrbanCage<sup className="trademark">{'\u00AE'}</sup></span> in action</>
        )}
      </h2>
      <div className="video-grid">
        {videoUrls.map((url) => {
          const videoId = url.split('/').pop();
          return (
            <LazyVideo 
              key={`video-${videoId}`}
              url={url} 
              title={`UrbanCage ${language === 'cs' ? 'multisportovní hřiště' : 'multi-sport court'} - ${videoId}`}
            />
          );
        })}
      </div>
    </section>
  );
};

export default React.memo(VideoSection);
